exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.CardGroup{position:relative\n}\n.CardGroup .CardGroupMessage{padding:0 32px;padding:0 2rem;position:absolute;top:50%;width:100%;z-index:999;-webkit-transform:translateY(-50%);transform:translateY(-50%)\n}\n.CardGroup .CardElement:not(.tight) .CardWrap{margin-left:4px;margin-left:0.25rem;margin-right:4px;margin-right:0.25rem\n}\n.CardGroup .CardElement:not(.tight):first-child .CardWrap{margin-left:0\n}\n.CardGroup .CardElement:not(.tight):last-child .CardWrap{margin-right:0\n}\n", ""]);

// exports
